/**
 * Home — pantalla de entrada del Pórtico (GEN-PX-007). Estado inicial de una
 * conversación nueva sin dirigir (borrador que enruta Anne).
 *
 * Solo arma el contexto y delega en la estructura de despacho/entrada: orden
 * fijo de secciones, vacías ocultas. El cuadro de conversación fijo (GEN-PX-004)
 * lo monta ChatWindow. Todo data-driven desde el descriptor (R-PT-02).
 */

import Entrada from '../despacho/entrada/Entrada.jsx'
import { orquestadoraDe } from '../lib/cuadro.js'

export default function Home({
  user, agents = [], chats = [], palette, theme,
  onSelectAgent, onSelectChat, onVerEquipo, onVerPersonas, onInvitar, onVerPerfil,
}) {
  // Solo los agentes DISPONIBLES (operativos) en la entrada (Guo 2026-07-16).
  const disponibles = agents.filter(a => a.puede_iniciar_chat !== false)
  const enrutadora = orquestadoraDe(agents)?.nombre ?? 'Anne'
  return (
    <Entrada ctx={{ user, agents, chats, disponibles, enrutadora, palette, theme, onSelectAgent, onSelectChat, onVerEquipo, onVerPersonas, onInvitar, onVerPerfil }} />
  )
}
